import parse from './fill'

export default {
    parse
}
